<template>

  <div id="outstudy_container">
    <b-card border-variant="info" header="学習結果表示" class="text-center">

    <ChartLine id="outstudy_graph" :chartData="chartDatas" :options="chartOptions" class="linechart"></ChartLine>

    <div class="trainDispCls" v-if="trainDispShow"><strong>{{dispMessage}}【{{progCount}}/{{totalInCount}}】</strong>
    <b-spinner label="Loading..." variant="danger" v-show="spinnerShow">Loading...</b-spinner></div>
    <div id="testViewDiv" v-if="debugDisp"></div>

    </b-card>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import * as tf from '@tensorflow/tfjs'
import ChartLine from '@/components/ChartLine.vue'

const batchSize = 512
const width = 28
const height = 28
const channel = 1

export default {
  name: 'outstudy',
  data () {
    return {
      m_in: 0,
      m_img: 0,
      output_classes: 2,
      dispMessage: '',
      spinnerShow: false,
      chartDatas: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Epochs [学習回数]'
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                min: 0
              }
            }, // 左の軸。他の設定はデフォルトのまま
            {
              id: 'y-axis-2',
              position: 'right', // 右に表示する
              ticks: {
                min: 0,
                max: 1,
                callback: (label, index, labels) => (label * 100).toLocaleString() + '%'
              }
            }
          ]
        },
        tooltips: { // ツールチップの設定
          mode: 'index' // 全データを表示する
        }
      },
      progCount: 0,
      totalInCount: 500,
      trainDispShow: false,
      lineLabels: [],
      lossData: [],
      accData: [],
      vlossData: [],
      vaccData: [],
      trainxdata: [], // ４次元データ、Input数 * 176*144*4
      trainydata: [], // １次元データ */
      trainDataSize: 0,
      testxdata: [], // ４次元データ、Input数 * 176*144*4
      testydata: [], // １次元データ */
      testDataSize: 0,
      debugDisp: false
    }
  },
  components: {
    ChartLine
  },
  computed: {
    ...mapState([ 'manualInputFlag', 'samplebtn', 'aimodels', 'aimodelpara', 'inputs', 'iimages', 'aidatas', 'resultGraph' ]),
    consolevue: () => console.error
    // -------------------------------- Graph --------------------------------
    /* lossData () {
      var tmpArr = []
      for (var i = 1; i <= this.aimodelpara.epochs; i++) {
        tmpArr.push(0.1 * i)
      }
      return tmpArr
    },
    accData () {
      var tmpArr = []
      for (var i = 1; i <= this.aimodelpara.epochs; i++) {
        tmpArr.push(0.2 * i)
      }
      return tmpArr
    } */
    // -------------------------------- Graph --------------------------------
  },
  methods: {
    // -------------------------------- AI TRAIN --------------------------------
    doAiTrain () {
      this.spinnerShow = true
      // Graph更新
      this.lossData = []
      this.accData = []
      this.vlossData = []
      this.vaccData = []
      this.updateChartData(true, false)
      this.progCount = 0
      this.totalInCount = this.iimages.length
      this.trainDispShow = true
      // 表示処理
      // this.$store.dispatch('setProgbar', { s_value: 3, s_show: true }) // ProgressBar表示
      this.$store.dispatch('setMessage', 'AI DATA Reading...')
      this.dispMessage = 'Data Processing...'
      // Input Data loading...
      if (this.iimages.length === 0) {
        this.closeTrain('入力データをセットして下さい。')
        return
      }
      setTimeout(this.doAiTrainLoad, 100) // ここまでのメッセージ表示を反映させる
    },
    async doAiTrainLoad () {
      var stopFlag = false // foreach内のreturnは関数全体が止まらないのでFlagでStop
      /* 配列データはうまく学習できない
      this.iimages.forEach(eachdata => {
        var findIndex = this.aidatas.findIndex(aidata => (aidata.in_num === eachdata.in_num && aidata.img_num === eachdata.img_num))
        var aiDataArr = this.aidatas[findIndex].ai_data
        // console.log('aiDataArr.length:' + String(aiDataArr.length))
        // console.log(aiDataArr)
        if (aiDataArr.length === 0) {
          stopFlag = true // ここでのreturnはforeachを抜ける
          return
        }
        // Push each Input for All
        this.allxdata.push(aiDataArr)
        this.allydata.push(eachdata.in_num)
      }) */
      // console.log(this.allxdata)
      // console.log(this.allydata)
      // Create Input Length
      /* const noDup = this.allydata.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
      this.output_classes = noDup.length
      if (this.output_classes <= 1) {
        this.closeTrain('入力データは２つ以上設定して下さい。')
        return
      } */
      this.output_classes = this.inputs.length
      // Test用データ分割サイズ決定
      if (this.aimodelpara.valid === 0) {
        this.testDataSize = 0
      } else {
        this.testDataSize = Math.floor(this.iimages.length * this.aimodelpara.valid / 100)
      }
      this.trainDataSize = this.iimages.length - this.testDataSize
      // Train,Testデータ作成
      const trainBytesBuffer = new ArrayBuffer(this.trainDataSize * (width * height) * 4) // 仮保存用配列バッファ
      this.trainydata = new Uint8Array(this.trainDataSize * this.output_classes) // output_classes(one-hot)
      const testBytesBuffer = new ArrayBuffer(this.testDataSize * (width * height) * 4) // 仮保存用配列バッファ
      this.testydata = new Uint8Array(this.testDataSize * this.output_classes) // output_classes(one-hot)
      // datasetBytesBufferをFloat32Arrayに置き換えてByte操作する
      // datasetBytesBufferに第二引数の場所に第３引数分のFloat32Arrayを作成
      const trainBytesView = new Float32Array(trainBytesBuffer, 0, ((width * height) * this.trainDataSize))
      const testBytesView = new Float32Array(testBytesBuffer, 0, ((width * height) * this.testDataSize))
      var i = 0
      var trainCount = 0
      var testCount = 0
      var imageCount = new Array(this.output_classes) // 各InputのImage設定数をチェック
      imageCount.fill(0)
      for (var key in this.iimages) {
        var trainFlag = true // TrainDataとTestDataをランダムに分割する
        // ランダムにテスト用へ
        if (Math.random() < (this.aimodelpara.valid / 100)) {
          // テストデータ数を超えていない場合のみテスト用データへ
          if (testCount < this.testDataSize) {
            trainFlag = false
          }
        }
        // 訓練データ数を超えていたらテスト用データへ
        if (trainCount >= this.trainDataSize) {
          trainFlag = false
        }
        imageCount[this.iimages[key].in_id]++
        if (this.iimages[key].img_data === '') {
          stopFlag = true // ここでのreturnはforeachを抜ける
          console.log('noDataStop')
          break
        }
        // ----------------- 画像をArrayBuffer配列で作成 ----------------
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        var ctx = canvas.getContext('2d')
        // 画像オブジェクトを生成
        const img = await this.loadImage(this.iimages[key].img_data)
        // 画像データをCanvasにアサインしイメージデータ取得
        ctx.drawImage(img, 0, 0)
        if (this.debugDisp && i < 11) {
          canvas.style = 'margin: 2px; outline: black 1px solid;'
          document.getElementById('testViewDiv').appendChild(canvas)
        }
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        // 画像データを保存する（グレースケールで処理、RGBは同じ値なのでRedのみ保存：TensorFlowのdata.jsを踏襲）
        for (let j = 0; j < imageData.data.length / 4; j++) {
          if (trainFlag) {
            trainBytesView[(i * width * height) + j] = imageData.data[j * 4] / 255
          } else {
            testBytesView[(i * width * height) + j] = imageData.data[j * 4] / 255
          }
        }
        // ----------------- LabelをOneHotでFloat32Array配列で作成 ----------------
        for (let j = 0; j < this.output_classes; j++) {
          if (trainFlag) {
            if (this.iimages[key].in_id === j) {
              this.trainydata[(trainCount * this.output_classes) + j] = 0x01
            } else {
              this.trainydata[(trainCount * this.output_classes) + j] = 0x00
            }
          } else {
            if (this.iimages[key].in_id === j) {
              this.testydata[(testCount * this.output_classes) + j] = 0x01
            } else {
              this.testydata[(testCount * this.output_classes) + j] = 0x00
            }
          }
        }
        if (trainFlag) {
          trainCount++
        } else {
          testCount++
        }
        i++
        this.progCount = i
      }
      // Stopフラグを判定しデータ漏れがあればSTOP
      if (stopFlag) { // foreach内のreturnは関数全体が止まらないのでFlagでStop
        this.closeTrain('入力データは全て設定して下さい。')
        console.log('Need Input data')
        return
      }
      // 各InputのImage設定数をチェック
      for (let j = 0; j < this.output_classes; j++) {
        if (imageCount[j] < 5) {
          this.closeTrain('各入力ラベルは5個以上設定して下さい')
          console.log('Need 5 Image data')
          return
        }
      }
      // 画像のFloat32Array配列データ作成
      this.trainxdata = new Float32Array(trainBytesView) // Float32:RGBA(4Byte=>32Bit)
      this.testxdata = new Float32Array(testBytesView) // Float32:RGBA(4Byte=>32Bit)
      // Create Model
      this.$store.dispatch('setMessage', 'AI Model Creating...')
      console.log('AI Model Creating...')
      this.dispMessage = 'Model Creating...'
      setTimeout(this.doAiTrainCommit, 100) // ここまでのメッセージ表示を反映させる
    },
    loadImage (dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = (e) => reject(e)
        img.src = dataUrl
      })
    },
    async doAiTrainCommit () {
      // Create Model
      const model = this.createModel()
      if (model === null) {
        return
      }
      // Train AI
      this.$store.dispatch('setMessage', 'Start AI Training...')
      console.log('Start AI Training...')
      this.dispMessage = 'AI Training...'
      this.totalInCount = this.aimodelpara.epochs
      this.progCount = 0
      /* 配列データはうまく学習できない
      const tfXd = tf.stack(this.allxdata)
      const tfYd = tf.oneHot(this.allydata, this.output_classes) */
      // tensor2dでTensorFlow用データへ対応
      const tfXd = tf.tensor2d(this.trainxdata, [this.trainDataSize, (width * height)]).reshape([this.trainDataSize, width, height, channel])
      const tfYd = tf.tensor2d(this.trainydata, [this.trainDataSize, this.output_classes])
      const testXs = tf.tensor2d(this.testxdata, [this.testDataSize, (width * height)]).reshape([this.testDataSize, width, height, channel])
      const testYs = tf.tensor2d(this.testydata, [this.testDataSize, this.output_classes])
      // const tfXd = tmpX.reshape([this.iimages.length, width, height, channel])
      // const history = await model.fit(tf.stack(allxdata), tf.oneHot(allydata), {
      var history = null
      // ０の場合はValidationなし
      // console.log('valid:' + this.aimodelpara.valid + ':' + this.trainDataSize + ':' + this.testDataSize)
      if (this.aimodelpara.valid === 0) {
        history = await model.fit(tfXd, tfYd, {
          batchSize: batchSize,
          epochs: this.aimodelpara.epochs,
          callbacks: {onEpochEnd: (epoch, logs) => this.pushGrapdata(epoch, logs)}
        })
      } else {
        history = await model.fit(tfXd, tfYd, {
          batchSize: batchSize,
          validationData: [testXs, testYs],
          epochs: this.aimodelpara.epochs,
          callbacks: {onEpochEnd: (epoch, logs) => this.pushGrapdata(epoch, logs)}
        })
      }
      this.$store.dispatch('setAiResult', {loss: this.lossData, acc: this.accData, vloss: this.vlossData, vacc: this.vaccData, model: model})
      console.log(history.history.loss[0])
      this.closeTrain('学習が完了しました。上部タブを切り替えてAI予測を試して下さい。')
    },
    createModel () {
      // 念のためソート
      // console.log(this.aimodels)
      const sortModels = this.aimodels.sort((a, b) => {
        return (a.no < b.no) ? -1 : (a.no > b.no) ? 1 : 0
      })
      // Model作成
      const model = tf.sequential()
      var firstFlag = true
      var checkDenseOrConv = true
      var checkFlat = true
      for (var key in sortModels) {
        if (sortModels[key].type === 'Conv') {
          checkDenseOrConv = false
          if (firstFlag) {
            model.add(tf.layers.conv2d({
              inputShape: [height, width, channel],
              kernelSize: 5,
              strides: 1,
              filters: parseInt(sortModels[key].val1),
              activation: sortModels[key].val2,
              kernelInitializer: 'varianceScaling'
            }))
          } else {
            model.add(tf.layers.conv2d({
              kernelSize: 5,
              strides: 1,
              filters: parseInt(sortModels[key].val1),
              activation: sortModels[key].val2,
              kernelInitializer: 'varianceScaling'
            }))
          }
        } else if (sortModels[key].type === 'Dense') {
          checkDenseOrConv = false
          if (firstFlag) {
            model.add(tf.layers.dense({
              inputShape: [height, width, channel],
              units: parseInt(sortModels[key].val1),
              activation: sortModels[key].val2,
              kernelInitializer: 'varianceScaling'
            }))
          } else {
            model.add(tf.layers.dense({
              units: parseInt(sortModels[key].val1),
              activation: sortModels[key].val2,
              kernelInitializer: 'varianceScaling'
            }))
          }
        } else if (sortModels[key].type === 'Pool') {
          if (firstFlag) {
            model.add(tf.layers.maxPooling2d({inputShape: [height, width, channel], poolSize: [2, 2], strides: [2, 2]}))
          } else {
            model.add(tf.layers.maxPooling2d({poolSize: [2, 2], strides: [2, 2]}))
          }
        } else if (sortModels[key].type === 'Flat') {
          checkFlat = false
          if (firstFlag) {
            model.add(tf.layers.flatten({inputShape: [height, width, channel]}))
          } else {
            model.add(tf.layers.flatten())
          }
        } else if (sortModels[key].type === 'Drop') {
          if (firstFlag) {
            model.add(tf.layers.dropout({inputShape: [height, width, channel], rate: parseFloat(sortModels[key].val1)}))
          } else {
            model.add(tf.layers.dropout(parseFloat(sortModels[key].val1)))
          }
        }
        firstFlag = false
      }
      if (checkFlat) {
        this.closeTrain('Flatをモデルに設定し下さい')
        return null
      }
      if (checkDenseOrConv) {
        this.closeTrain('DenseもしくはConvをモデルに設定し下さい')
        return null
      }
      // 出力僧
      model.add(tf.layers.dense({
        units: this.output_classes,
        kernelInitializer: 'varianceScaling',
        activation: 'softmax'
      }))
      // Modelコンパイル
      var optimizer = tf.train.adadelta()
      if (this.aimodelpara.optim === 'adam') {
        optimizer = tf.train.adam()
      } else if (this.aimodelpara.optim === 'sgd') {
        optimizer = tf.train.sgd(0.01)
      } else if (this.aimodelpara.optim === 'momentum') {
        optimizer = tf.train.momentum(0.01, 0.9)
      } else if (this.aimodelpara.optim === 'adagrad') {
        optimizer = tf.train.adagrad(0.01)
      }
      model.compile({
        optimizer: optimizer,
        loss: 'categoricalCrossentropy',
        metrics: ['accuracy']
      })
      return model
      /* const model = tf.sequential()
      model.add(tf.layers.conv2d({ inputShape: [height, width, 3], kernelSize: 3, filters: 32, activation: 'relu' }))
      model.add(tf.layers.conv2d({kernelSize: 3, filters: 64, activation: 'relu'}))
      model.add(tf.layers.maxPooling2d({poolSize: 2, strides: 2}))
      model.add(tf.layers.dropout(0.25))
      model.add(tf.layers.flatten())
      model.add(tf.layers.dense({units: 128, activation: 'relu'}))
      model.add(tf.layers.dropout(0.5))
      model.add(tf.layers.dense({units: this.output_classes, activation: 'softmax'}))
      const optimizer = tf.train.adadelta()
      model.compile({
        optimizer: optimizer,
        loss: 'categoricalCrossentropy',
        metrics: ['accuracy']
      })
      return model */
      /* const model = tf.sequential()
      model.add(tf.layers.conv2d({ inputShape: [height, width, 3], kernelSize: 5, filters: 8, strides: 1, activation: 'relu', kernelInitializer: 'varianceScaling' }))
      model.add(tf.layers.maxPooling2d({poolSize: [2, 2], strides: [2, 2]}))
      model.add(tf.layers.conv2d({ kernelSize: 5, filters: 16, strides: 1, activation: 'relu', kernelInitializer: 'varianceScaling' }))
      model.add(tf.layers.maxPooling2d({poolSize: [2, 2], strides: [2, 2]}))
      model.add(tf.layers.flatten())
      model.add(tf.layers.dense({ units: this.output_classes, kernelInitializer: 'varianceScaling', activation: 'softmax' }))
      const optimizer = tf.train.adam()
      model.compile({ optimizer: optimizer, loss: 'categoricalCrossentropy', metrics: ['accuracy'] })
      return model */
    },
    closeTrain (clsMessage) {
      this.spinnerShow = false // spinner表示（Table下）
      this.$store.dispatch('setMessage', clsMessage) // メッセージ表示
      this.$store.dispatch('setTrainDisable', false) // 「学習」ボタンDisable化
      // this.$store.dispatch('setProgbar', { s_value: 0, s_show: false }) // ProgressBar表示
      this.trainDispShow = false
    },
    // -------------------------------- AI TRAIN --------------------------------
    // -------------------------------- GRAPH --------------------------------
    updateChartData (labelFlag, dataUpdate) {
      // Label更新フラグあり時のみ更新
      if (labelFlag) {
        this.lineLabels = []
        for (var i = 1; i <= this.aimodelpara.epochs; i++) {
          this.lineLabels.push(i)
        }
      }
      if (dataUpdate) {
        this.lossData = this.resultGraph.loss
        this.accData = this.resultGraph.acc
        this.vlossData = this.resultGraph.vloss
        this.vaccData = this.resultGraph.vacc
      }
      this.chartDatas = {
        labels: this.lineLabels,
        datasets: [
          {
            label: 'Loss [損失関数]',
            borderColor: 'orange',
            borderWidth: 1,
            // data: this.resultGraph.loss
            data: this.lossData
          },
          /* {
            label: 'val_Loss [損失関数]',
            borderColor: 'red',
            borderWidth: 1,
            // data: this.resultGraph.loss
            data: this.vlossData
          }, */
          {
            yAxisID: 'y-axis-2', // Y軸のIDを指定
            label: 'Acc [正解率] 　',
            borderColor: 'limegreen',
            borderWidth: 1,
            // data: this.resultGraph.acc
            data: this.accData
          }
          /* },
          {
            yAxisID: 'y-axis-2', // Y軸のIDを指定
            label: 'val_Acc [正解率]   ',
            borderColor: 'blue',
            borderWidth: 1,
            // data: this.resultGraph.acc
            data: this.vaccData
          } */
        ]
      }
    },
    pushGrapdata (epoch, llogs) {
      // console.log('epoch' + String(epoch) + ':' + String(llogs.loss) + ':' + String(llogs.acc))
      this.lossData.push(llogs.loss)
      this.accData.push(llogs.acc)
      this.vlossData.push(llogs.val_loss)
      this.vaccData.push(llogs.val_acc)
      this.updateChartData(false, false)
      // var progRate = epoch / this.aimodelpara.epochs * 100
      // this.$store.dispatch('setProgbar', { s_value: progRate, s_show: true }) // ProgressBar表示
      this.progCount = epoch
    }
  },
  mounted () {
    this.updateChartData(true, false)
  }
  // -------------------------------- GRAPH --------------------------------
}
</script>
<style scoped>
div.card-body {
  width: 334px;
  padding: 10px 0;
}
.linechart {
  width: 334px;
  height: 290px;
}
.trainDispCls {
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/OutStudy.vue